import { createSlice } from '@reduxjs/toolkit';

import { appReducer } from './components/AppShell/reducer';
import { httpReducer } from './http/reducer';

// Reserved slice name for socket telemetry; empty until real emitters land.
const socketsTestSlice = createSlice({
  name: 'socketsTest',
  initialState: { events: [] as Array<{ type: string; at: number }> },
  reducers: {
    recordEvent(state, action: { payload: { type: string } }) {
      state.events.push({ type: action.payload.type, at: Date.now() });
      if (state.events.length > 100) state.events.shift();
    },
    clear(state) {
      state.events = [];
    },
  },
});

export const socketsTestActions = socketsTestSlice.actions;

export const commonReducers = {
  app: appReducer,
  http: httpReducer,
  socketsTest: socketsTestSlice.reducer,
};

export default commonReducers;
